/**
 * Plan copy and the feature comparison, verbatim from iOS
 * `UI/Settings/SubscriptionView.swift` (SubscriptionProduct, SubscriptionCatalog).
 */

export const PLAN_COPY = {
  title: "Choose your plan.",
  startTrial: "Start free trial",
  startingTrial: "Starting your trial…",
  subscribe: "Continue",
  free: "I just want a free plan for now.",
  compare: "Compare all features",
  hideCompare: "Hide comparison",
} as const;

export const PAID_PLANS = [
  {
    type: "plus" as const,
    name: "Plus" as const,
    blurb: "Get your daily readiness score & fundamentals to training like an athlete",
  },
  {
    type: "premium" as const,
    name: "Premium" as const,
    blurb: "Unlock the intelligence layer with early access to new tools.",
  },
];

export type CompareValue = "included" | "excluded" | { count: string };

export interface CompareFeature {
  name: string;
  free: CompareValue;
  plus: CompareValue;
  premium: CompareValue;
}

export interface CompareSection {
  id: string;
  title: string;
  features: CompareFeature[];
}

const all = (name: string): CompareFeature => ({ name, free: "included", plus: "included", premium: "included" });
const plusUp = (name: string): CompareFeature => ({ name, free: "excluded", plus: "included", premium: "included" });
const premiumOnly = (name: string): CompareFeature => ({ name, free: "excluded", plus: "excluded", premium: "included" });

export const COMPARE_SECTIONS: CompareSection[] = [
  {
    id: "logging",
    title: "LOGGING & TRAINING DIARY",
    features: [
      plusUp("Peak Score"),
      plusUp("Heart Lung Recovery Index"),
      all("Training (RPE) & wellness diary"),
      all("Recovery, performance, niggle, injury & notes"),
      all("Custom tags & multiple sports"),
      all("Session load modifiers"),
      all("Female cycle logging (dates & graph)"),
      plusUp("Export data to CSV"),
      plusUp("Performance goals (date & value)"),
    ],
  },
  {
    id: "tools",
    title: "IN-APP TOOLS (iOS & ANDROID)",
    features: [premiumOnly("Breathing exercises")],
  },
  {
    id: "graphs",
    title: "GRAPHS, TRENDS & ANALYTICS",
    features: [
      all("Load vs wellness analysis"),
      plusUp("Load Balance"),
      plusUp("Peak Readiness"),
      plusUp("Performance & activity analysis"),
    ],
  },
  {
    id: "wearables",
    title: "WEARABLES",
    features: [
      {
        name: "Connected devices (Garmin, Oura, Whoop & more)",
        free: { count: "1" },
        plus: { count: "2" },
        premium: { count: "3" },
      },
    ],
  },
  {
    id: "ai",
    title: "AI",
    features: [
      premiumOnly("The Wizard analysis"),
      premiumOnly("Individualised AI insights"),
      premiumOnly("Custom insights & Wizard tone"),
    ],
  },
  {
    id: "planner",
    title: "SESSIONS & TRAINING PLANNER",
    features: [
      all("Exercise library (all activity packs)"),
      all("Planner & scheduled sessions"),
      plusUp("Saved session templates, activities & exercises"),
      plusUp("Add events & link to sessions"),
    ],
  },
  {
    id: "security",
    title: "SECURITY",
    features: [all("Two-factor authentication"), all("Session management & verified accounts")],
  },
];
